import './App.css';
import './index.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loginSuccess } from './redux/authSlice';
import apiClient from './utils/apiClient';

import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ThePulse from './pages/ThePulse';
import TheStudio from './pages/TheStudio';
import TheVault from './pages/TheVault';
import TheGreenhouse from './pages/TheGreenhouse';
import TheBlueprint from './pages/TheBlueprint';
import TheLens from './pages/TheLens';
import TheIdentity from './pages/TheIdentity';
import TaskCreation from './pages/TaskCreation';
import PrivacyPolicy from './pages/PrivacyPolicy';
import DeleteAccount from './pages/DeleteAccount';
import Blogs from './pages/Blogs';
import BlogPost from './pages/BlogPost';
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './components/AppLayout';

function AppRoutes() {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem('multiauthor_token');
    if (token) {
      dispatch(loginSuccess({ token, user: null }));
      apiClient.get('/auth/me/')
        .then(r => dispatch(loginSuccess({ token, user: r.data })))
        .catch(() => {});
    }
  }, [dispatch]);

  return (
    <Routes>
      {/* Public routes - no app layout */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      
      {/* Protected routes with app layout */}
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <AppLayout><ThePulse /></AppLayout>
        </ProtectedRoute>
      } />
      <Route path="/studio" element={
        <ProtectedRoute>
          <AppLayout><TheStudio /></AppLayout>
        </ProtectedRoute>
      } />
      <Route path="/vault" element={
        <ProtectedRoute>
          <AppLayout><TheVault /></AppLayout>
        </ProtectedRoute>
      } />
      <Route path="/feed" element={
        <ProtectedRoute>
          <AppLayout><TheGreenhouse /></AppLayout>
        </ProtectedRoute>
      } />
      <Route path="/pipeline" element={
        <ProtectedRoute>
          <AppLayout><TheBlueprint /></AppLayout>
        </ProtectedRoute>
      } />
      <Route path="/insights" element={
        <ProtectedRoute>
          <AppLayout><TheLens /></AppLayout>
        </ProtectedRoute>
      } />
      <Route path="/profile" element={
        <ProtectedRoute>
          <AppLayout><TheIdentity /></AppLayout>
        </ProtectedRoute>
      } />
      <Route path="/task-creation" element={
        <ProtectedRoute>
          <AppLayout><TaskCreation /></AppLayout>
        </ProtectedRoute>
      } />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/delete-account" element={<DeleteAccount />} />
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/blogs/:slug" element={<BlogPost />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
